// axiosRequest.ts

import axios, { AxiosRequestConfig } from 'axios';
import Cookies from 'js-cookie';

let portalRefreshPromise: Promise<void> | null = null;

const normalizeApiUrl = (url: string) => url.endsWith('/') ? url : `${url}/`;

const refreshPortalSession = async (portalApiUrl: string): Promise<void> => {
  if (!portalRefreshPromise) {
    const username = sessionStorage.getItem('portal_user_email');
    const userId = sessionStorage.getItem('portal_user_id');
    const userType = sessionStorage.getItem('portal_user_type');

    portalRefreshPromise = axios({
      method: 'post',
      url: `${normalizeApiUrl(portalApiUrl)}refresh-token/`,
      withCredentials: true,
      data: {
        username,
        user_id: userId,
        user_type: userType,
      },
    })
      .then(() => undefined)
      .finally(() => {
        portalRefreshPromise = null;
      });
  }

  return portalRefreshPromise;
};

const axiosRequest = async (
  url: string,
  method: 'get' | 'post' | 'put' | 'patch' | 'delete',
  data?: any,
  configOverrides?: AxiosRequestConfig
) => {
  const csrfToken = Cookies.get('csrftoken');
  const idToken = Cookies.get('idToken');
  console.log('CSRF token in Safari:', csrfToken);
  console.log('ID token available:', idToken ? 'Yes' : 'No');
  
  const config: AxiosRequestConfig = {
    method: method,
    url: url,
    withCredentials: true, // Include cookies
    headers: {
      'X-CSRFToken': csrfToken || '', // Include CSRF token if needed
      ...(idToken && { 'Authorization': `Bearer ${idToken}` }), // Include Authorization header if idToken available
    },
    data: data,
    ...configOverrides, // Allow overrides like responseType
  };

  try {
    const response = await axios(config);
    return response;
  } catch (error: any) {
    const portalApiUrl = process.env.REACT_APP_PORTAL_AUTH_API_URL || process.env.REACT_APP_SIGNIN_API_URL;
    const isPortalRequest = !!portalApiUrl && url.startsWith(normalizeApiUrl(portalApiUrl));
    const isPublicPortalAuthRequest = [
      '/signin/',
      '/signup/',
      '/refresh-token/',
      '/forgot-password/',
      '/confirm-forgot-password/',
    ].some(path => url.includes(path));

    if (error.response?.status === 401 && isPortalRequest && !isPublicPortalAuthRequest) {
      try {
        await refreshPortalSession(portalApiUrl);
        return await axios(config);
      } catch (refreshError) {
        console.error('Unable to refresh portal session:', refreshError);
      }
    }

    throw error;
  }
};

export default axiosRequest;
